module.exports = __webpack_public_path__ + "img/logo-notext.abf2e640.svg";